import { format } from "date-fns";
import React from "react";
import { BsEnvelope, BsFillTelephoneFill } from "react-icons/bs";
import { useParams } from "react-router-dom";
import orgApi from "../../api/org_api";
import { Table, Text } from "../../component/common";
import { getTz } from "../../utils/CommonMethods";
type SingleDateScheduleProps = { setLoading: Function };

const SingleDateSchedule: React.FC<SingleDateScheduleProps> = ({
  setLoading,
}: SingleDateScheduleProps) => {
  const [candidateList, setCandidateList] = React.useState([] as any);

  const { date } = useParams();
  React.useEffect(() => {
    fetchSchedules();
  }, []);

  const fetchSchedules = async () => {
    setLoading(true);
    var userInfo = JSON.parse(
      localStorage.getItem("user__details")?.toString()!
    );
    var orgId = userInfo.id;
    var reqData = { day: format(new Date(date!), "yyyy-MM-dd") };
    const res = await orgApi.fetchSingledateSchedule(orgId, reqData);
    res.data.success && setCandidateList(res.data.schedule);
    setLoading(false);
  };



  const getTableData = () => {
    return {
      columns: [
        {
          label: "Candidate Details",
          accessor: "candidate_details",
          className: "w-2/6",
        },
        { label: "Post Title", accessor: "post_title" },
        { label: "Interview Date", accessor: "interview_date" },
        {
          label: "Interview Time",
          accessor: "interview_time",
          className: "w-1/5",
        },
        { label: "Status", accessor: "status" },
      ],
      data:
        candidateList &&
        candidateList.length > 0 &&
        candidateList.map((value: any) => ({
          candidate_details: (
            <div className="flex flex-col items-start gap-1">
              <Text
                className="font-semibold max-w-40 truncate "
                text={value.candidate.first_name}
              />

              <p className="flex flex-row items-center gap-1">
                <BsEnvelope /> &nbsp;
                <Text
                  className="max-w-40 truncate "
                  text={value.candidate.email}
                />
              </p>
              <p className="flex flex-row items-center gap-1">
                <BsFillTelephoneFill /> &nbsp;
                <Text
                  className="max-w-40 truncate "
                  text={value.candidate.mobile}
                />
              </p>
            </div>
          ),
          post_title: <Text className="max-w-52 truncate" text={value.post.job_title} />,
          interview_date: format(value.utc_starttime, "dd MMM yyyy"),
          interview_time: `${format(
            value.utc_starttime,
            "hh:mm a"
          )} to ${format(value.utc_endtime, "hh:mm a")} ${getTz(
            value.candidate_tz
          )}`,
          status: <span className="text-green-500">{value.status}</span>,
        })),
    };
  };

  return (
    <>
      <div className="flex flex-col h-[calc(100vh-100px)] 2xl:h-[calc(100vh-120px)]">
        <div className="m-2 overflow-y-auto">
          <Table
            {...getTableData()}
            isStickyHeader
            containerHeight="h-[calc(100vh-120px)] 2xl:h-[calc(100vh-140px)]"
          />
        </div>
      </div>
    </>
  );
};

export default SingleDateSchedule;
